import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({ 0: true });

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev?.[index]
    }));
  };

  const faqData = [
    {
      question: "How does the 14-day free trial work?",
      answer: `Start using Neevii immediately with full access to all features in your chosen plan. No credit card required to begin. After 14 days, choose the tier that fits your workflow or cancel with no charges. Your data remains yours regardless of your decision.`
    },
    {
      question: "Can I change my plan anytime?",
      answer: `Absolutely! You can upgrade or downgrade your plan at any time. When upgrading, you'll get immediate access to new features and pay the prorated difference. When downgrading, the change takes effect at your next billing cycle, and you keep access to premium features until then.`
    },
    {
      question: "What happens if I exceed my plan limits?",
      answer: `We'll notify you when you're approaching your limits. For transactions and AI processing, you can purchase additional capacity or upgrade your plan. We never cut off access suddenly - you'll always have time to adjust your plan or usage.`
    },
    {
      question: "How secure is my financial data?",
      answer: `Your data security is our top priority. We use bank-level 256-bit SSL encryption, are SOC 2 Type II certified, and maintain GDPR compliance. Your data is stored in secure, redundant data centers with 24/7 monitoring. We never sell or share your financial information.`
    },
    {
      question: "Can I export my data to QuickBooks or other software?",
      answer: `Yes! Neevii offers seamless export to QuickBooks, CSV files, and other popular accounting formats. You can also set up automatic syncing with QuickBooks Online. Your data is never locked in - you can export everything at any time.`
    },
    {
      question: "Do you offer refunds?",
      answer: `We offer a 30-day money-back guarantee on all paid plans. If you're not completely satisfied, contact us within 30 days of your first payment for a full refund. We also provide prorated refunds for annual plans if you cancel early.`
    },
    {
      question: "What kind of support do you provide?",
      answer: `Support varies by plan: Starter includes email support during business hours, Growth adds 24/7 email and live chat, Professional includes priority support plus phone access and a dedicated account manager. All plans include access to our comprehensive help center and video tutorials.`
    },
    {
      question: "How accurate is the AI categorization?",
      answer: `Our AI achieves 95%+ accuracy on expense categorization and improves over time as it learns your business patterns. You can always review and adjust categorizations, and the AI learns from your corrections. Most users find they need to manually adjust less than 5% of transactions after the first month.`
    },
    {
      question: "Can multiple team members access the account?",
      answer: `Yes! Growth plan includes 3 user seats, and Professional includes 10 seats. Additional users can be added for $10/month each. Each user has customizable permissions, so you can control who sees what financial information.`
    },
    {
      question: "What if I need features not included in any plan?",
      answer: `We offer custom enterprise solutions for businesses with unique needs. This includes custom integrations, advanced reporting, white-label options, and dedicated infrastructure. Contact our sales team to discuss your specific requirements and get a custom quote.`
    }
  ];

  return (
    <div className="bg-card rounded-2xl border border-border p-8">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-foreground mb-2">
          Frequently Asked Questions
        </h3>
        <p className="text-muted-foreground">
          Get answers to common questions about Neevii pricing and features
        </p>
      </div>
      <div className="space-y-4">
        {faqData?.map((item, index) => (
          <div
            key={index}
            className="border border-border rounded-xl overflow-hidden"
          >
            <button
              onClick={() => toggleItem(index)}
              className="w-full flex items-center justify-between p-6 text-left hover:bg-muted/5 transition-colors"
            >
              <span className="font-semibold text-foreground pr-4">
                {item?.question}
              </span>
              <Icon
                name={openItems?.[index] ? "ChevronUp" : "ChevronDown"}
                size={20}
                className="text-muted-foreground flex-shrink-0"
              />
            </button>
            
            {openItems?.[index] && (
              <div className="px-6 pb-6">
                <div className="pt-2 border-t border-border">
                  <p className="text-muted-foreground leading-relaxed">
                    {item?.answer}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Contact Support */}
      <div className="mt-8 pt-8 border-t border-border text-center">
        <h4 className="font-semibold text-foreground mb-2">
          Still have questions?
        </h4>
        <p className="text-muted-foreground mb-4">
          Our support team is here to help you choose the right plan
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="mailto:support@neevii.com"
            className="inline-flex items-center justify-center px-4 py-2 border border-border rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:border-accent transition-colors"
          >
            <Icon name="Mail" size={16} className="mr-2" />
            Email Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;